export const APP_VERSION = '4113c0b5';
